/**
 * 현재 경로 가져오기
 */
export function getCurrentPath(): string {
  return window.location.pathname;
}

/**
 * 현재 전체 URL 가져오기
 */
export function getCurrentUrl(): string {
  return window.location.href;
}

/**
 * 쿼리 파라미터를 객체로 파싱
 */
export function getQueryParams<T extends Record<string, string> = Record<string, string>>(): T {
  const params = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result as T;
}

/**
 * 특정 쿼리 파라미터 값 가져오기
 */
export function getQueryParam(key: string): string | null {
  return new URLSearchParams(window.location.search).get(key);
}

/**
 * URL에 쿼리 파라미터 추가
 */
export function buildUrlWithQuery(
  baseUrl: string,
  query: Record<string, string | number | boolean | undefined | null>
): string {
  const url = new URL(baseUrl, window.location.origin);
  Object.entries(query).forEach(([key, value]) => {
    if (value != null) {
      url.searchParams.set(key, String(value));
    }
  });
  // 외부 URL이면 전체 URL, 내부면 pathname + search
  return baseUrl.startsWith('http') ? url.toString() : `${url.pathname}${url.search}`;
}

/**
 * 현재 URL에서 특정 쿼리 파라미터 제거
 */
export function removeQueryParams(keys: string[]): void {
  const url = new URL(window.location.href);
  keys.forEach((key) => url.searchParams.delete(key));
  window.history.replaceState({}, document.title, `${url.pathname}${url.search}`);
}
